// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1cAN9","vLegacy":"SelectSecondary_vLegacy__8QqEU","error":"SelectSecondary_error__2oeK6","disabled":"SelectSecondary_disabled__3yLJy"};